// utils/createNewPlanDefaults.js

export function buildNewPlanDefaults(study, scenario, isSequentialCohort) {
  return {
    studyId: study.studyId,
    projectId: study.projectId,
    studyPlanType: scenario === "scenario-b" ? 2 : 1,
    pcn: study.projectId,
    studyName: study.studyName,
    sponsorName: study.sponsorName,
    indication: "",
    protocolTitle: "",
    studyPlanName: "",
    studyPlanDescr: "",
    studyPlanVersion: 1,
    croProjectStartDateMillis: null,
    finalProtocolStartDateMillis: null,
    croProjectStartToSiteIdDuration: null,
    siteIdToFinalProtocolDuration: null,
    regApprovalToFSIVDuration: null,
    screeningPeriodDuration: null,
    treatmentDuration: null,
    followUpDuration: null,
    tfedToDbLockDuration: null,
    dbLocktoCSRDuration: null,
    csrToTMFCloseAndReturnDuration: null,
    enrollmentRate: null,
    screenFailRate: null,
    dropOutRate: null,
    overallEnrollmentDuration: null,
    pauseEnrollmentAfterPatient: "",
    pauseEnrollmentDays: "",
    simOptSecondsSpentLimit: null,
    simOptUnimprovedScoreCalculationLimit: null,
    simOptRunId: null,
    simOptRunStatus: null,
    simOptRunMsg: null,
    clonedStudyPlanId: null,
    comments: "",
    scenarioStatus: "Draft",
    cohortType: isSequentialCohort ? 2 : 0,
    opportunityStage: "(unassigned)",
    isPersonalDraft: 1,
    templateFlag: 0,
    ownedBy: "",
    publishBy: null,
    publishTs: null,
    parameters: [
      {
        parameterScope: "STUDY",
        parameterId: 12,
        parameterName: "SITES_TO_ACTIVATE",
        parameterDescr: "Total number of sites to activate",
        lowerBound: null,
        upperBound: null,
        comments: "",
      },
      {
        parameterScope: "STUDY",
        parameterId: 13,
        parameterName: "SUBJECTS_TO_SCREEN",
        parameterDescr: "Total number of participants to screen",
        lowerBound: null,
        upperBound: null,
        comments: "",
      },
    ],
    milestones: [
      {
        milestoneScope: "STUDY",
        milestoneId: 138,
        milestoneName: "NUM_SITES_ACTIVATED",
        milestoneDescr: "Total number of sites activated",
        milestoneLabel: "Number of Activated Sites",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 141,
        milestoneName: "NUM_SUBJECTS_SCREENED",
        milestoneDescr: "Total number of participants screened",
        milestoneLabel: "Number of Participants Screened",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 144,
        milestoneName: "NUM_SUBJECTS_ENROLLED",
        milestoneDescr: "Total number of participants enrolled",
        milestoneLabel: "Number of Participants Enrolled",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 147,
        milestoneName: "NUM_SUBJECTS_TREATED",
        milestoneDescr: "Total number of participants treated",
        milestoneLabel: "Number of Participants Completing Treatment",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 150,
        milestoneName: "NUM_SUBJECTS_COMPLETED",
        milestoneDescr:
          "Total number of participants who completed the entire study (including follow-up)",
        milestoneLabel: "Number of Participants Completing Follow-Up",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 134,
        milestoneName: "DURATION_TO_SITE_ID",
        milestoneDescr: "Duration [days] from study start to site ID",
        milestoneLabel: "Site ID Finish",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 135,
        milestoneName: "DURATION_TO_SUBMISSION",
        milestoneDescr: "Duration [days] from study start to submission",
        milestoneLabel: "Regulartory Submission",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 136,
        milestoneName: "DURATION_TO_FIRST_REGULATORY_APPROVAL",
        milestoneDescr:
          "Duration [days] from Submission Date to first regulatory approval",
        milestoneLabel: "First Regulatory Approval",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 139,
        milestoneName: "DURATION_TO_FSIV",
        milestoneDescr:
          "Duration [days] from study start to first site initiation visit (FSIV)",
        milestoneLabel: "FSIV",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 142,
        milestoneName: "DURATION_TO_FPS",
        milestoneDescr:
          "Duration [days] from study start to first participant screened (FPS)",
        milestoneLabel: "First Participant Screened (FPS)",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 145,
        milestoneName: "DURATION_TO_FPI",
        milestoneDescr:
          "Duration [days] from study start to first participant in (FPI) / first participant first visit (FPFV)",
        milestoneLabel: "First Participant Enrolled (FPE)",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 146,
        milestoneName: "DURATION_TO_LPI",
        milestoneDescr:
          "Duration [days] from study start to last participant in (LPI) / last participant first visit (LPFV)",
        milestoneLabel: "Last Participant Enrolled (LPE)",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 148,
        milestoneName: "DURATION_TO_FPLV",
        milestoneDescr:
          "Duration [days] study start to first participant last visit (FPLV) / first participant last visit (FPLV)",
        milestoneLabel: "First Participant Completes Treatment",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 149,
        milestoneName: "DURATION_TO_LPLV",
        milestoneDescr:
          "Duration [days] from study start to last participant last visit (LPLV) / last participant last visit (LPLV)",
        milestoneLabel: "Last Participant Completes Treatment",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 151,
        milestoneName: "DURATION_TO_FPC",
        milestoneDescr:
          "Duration [days] from study start to first participant completed (FPC)",
        milestoneLabel: "First Participant Last Follow-Up Visit",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
      {
        milestoneScope: "STUDY",
        milestoneId: 152,
        milestoneName: "DURATION_TO_TFED",
        milestoneDescr:
          "Duration [days] study start to last participant completed (LPC) / treatment follow-up end date (TFED)",
        milestoneLabel: "Last Participant Last Follow-Up Visit",
        lowerBound: null,
        upperBound: null,
        levelOfConfidence: -1,
        comments: "",
        milestoneDateMillis: null,
      },
    ],
    countries: [],
  };
}